import React, { ReactElement, ReactNode } from 'react';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';

import useUserDataLayer from '~/lib/useUserDataLayer';

import { Footer, HijackedUser } from '~/components/global';
import SocialProofFooter from '~/components/global/SocialProofFooter';
import NavHeaderCheckout from '~/components/navigation/NavHeaderCheckout';
import { ScrollToTop } from '~/components/ui';

export default function CheckoutLayout({
  children,
  hideDistractions,
  className,
  ...props
}: {
  children: ReactNode;
  hideDistractions: boolean;
  className?: string;
}): ReactElement {
  const router = useRouter();

  useUserDataLayer();

  return (
    <div className={className} {...props}>
      <NextSeo
        title="Browse software deals for your business."
        titleTemplate="%s | AppSumo"
        description="Discover, buy, and sell the digital products you need to build a business you're passionate about. Uncover top productivity, marketing, content tools and more."
        twitter={{
          handle: '@appsumo',
          site: '@appsumo',
          cardType: 'summary_large_image',
        }}
        openGraph={{
          type: 'website',
          siteName: 'AppSumo',
          images: [
            {
              url: 'https://appsumo2-cdn.appsumo.com/static/images/meta/appsumo-logo-meta.png',
            },
          ],
          url: router.asPath,
        }}
      />
      <NavHeaderCheckout />
      <HijackedUser />
      <div className="mb-4 w-full md:mb-16">{children}</div>
      <SocialProofFooter />
      {!hideDistractions && <Footer />}
      <ScrollToTop />
    </div>
  );
}
